import React from 'react'
import { Content, Image, TextLink, TextMassage } from './Styled'
import { Troubleshooting } from "../../../images"
const BadGateway = () => {
    return (
        <Content>
            <Image src={Troubleshooting} />
            <TextMassage>
                Bad Gateway Error 502
            </TextMassage>
            <TextLink to='/'>
                الذهاب للرئيسية
            </TextLink>
        </Content>
    )
}

export default BadGateway